/**
 * Shared PostHog config. Imported by both:
 * - src/lib/analytics.ts — extension-side surfaces (service worker, popup,
 *   sidepanel, content script). Has chrome.* available.
 * - src/welcome/analytics.ts — public onboarding page (Cloudflare Pages for
 *   non-RU, the RU VPS for RU/unknown). No chrome.* available; receives
 *   distinct_id / version / locale via URL params.
 *
 * Keep host, capture path, extension name and event names here so a region
 * migration or rebrand changes one file instead of two.
 */

export const POSTHOG_HOST = 'https://eu.i.posthog.com';
export const POSTHOG_CAPTURE_PATH = '/i/v0/e/';
export const EXTENSION_NAME = 'website-feedback-tool';
export const POSTHOG_API_KEY_ENV = 'VITE_POSTHOG_KEY';

/** Canonical event names — single source of truth across surfaces. */
export const POSTHOG_EVENTS = {
  installed: 'extension_installed',
  // Onboarding page actually loaded (fired by src/welcome/, not the SW).
  // Complements `installed` — the SW fires that even if the welcome tab
  // never opens / fails to load, so this is the "reached onboarding" funnel
  // step (especially meaningful for RU, where the page is the fix target).
  welcomeViewed: 'welcome_viewed',
  updated: 'extension_updated',
  active: 'extension_active',
  firstComment: 'first_comment_added',
  reviewExported: 'review_exported',
  commentCopied: 'comment_copied',
  shareFailed: 'share_failed',
  recordingCompleted: 'recording_completed',
  recordingFailed: 'recording_failed',
  uninstalled: 'extension_uninstalled',
} as const;
